module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "body1.6a64dc88.svg" + "?" + Date.now();